import { Inject, Injectable, Renderer2 } from '@angular/core';
import { AuthRefreshTokenDto, LoginRequestDto, LoginResponseDto, QueryRequestDto,  SingleResponseDto, TokensDto } from '@bugz-mono/shared-dtos';
import { AuthApiService, RolesApiService } from '@bugz-mono/shared-services';
import { BehaviorSubject, finalize, Observable, of, tap } from 'rxjs';
import { SnackbarService } from './snackbar.service';
import { environment } from '@bugz-mono/shared-environments';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class AccountsService {
    accessToken?: string|null=null;
    refreshToken?: string|null = null;

    private isRefreshing = false;
    private refreshTokenSubject = new BehaviorSubject<any>(null);

    logInStream: BehaviorSubject<boolean> = new BehaviorSubject(false);
    username?='';
    userStream: BehaviorSubject<string> = new BehaviorSubject('');
    permissionsStream: BehaviorSubject<string[]> = new BehaviorSubject(['']);
    
    toggleSideNav=true;
    private readonly themeLinkId = 'app-theme';
    toggleSideNavStream = new BehaviorSubject<boolean>(this.toggleSideNav);

    currentLogo?='';
    currentLogoStream: BehaviorSubject<string> = new BehaviorSubject('');
    
    constructor( 
        private router: Router,
        private http: HttpClient,
        private readonly snackbarService: SnackbarService,
        private authService : AuthApiService,
        private roleService : RolesApiService ) {
    }
    init(){
        this.accessToken = window.localStorage.getItem('accessToken');
        this.refreshToken = window.localStorage.getItem('refreshToken');
        if (this.accessToken) {
            this.logInStream.next(true);
        }
        const name =window.localStorage.getItem('userName');
        if(name){
            this.userStream.next(name);
        }
        const appLogo =window.localStorage.getItem('appLogo');
        if(appLogo){
            this.currentLogoStream.next(`${environment.appImageUrl}`+appLogo);
        }
        const permissions = window.localStorage.getItem('permissions');
        if (permissions) {
            this.permissionsStream.next(JSON.parse(permissions));
        }
        return of(null);
    }
    
    setToggleSideNav() {
        console.log('toggle value:', this.toggleSideNav);
        this.toggleSideNav = !this.toggleSideNav;
        console.log('changed toggled value:', this.toggleSideNav);
        this.toggleSideNavStream.next(this.toggleSideNav);
    }
    hasPermission(permission: string): boolean {
        const currentPermissions = this.permissionsStream.getValue(); // Get the current value of the BehaviorSubject
        return Array.isArray(currentPermissions) && currentPermissions.includes(permission) ? true : false;
    }
    async login(dto:LoginRequestDto): Promise<Observable<SingleResponseDto<LoginResponseDto>>>{
        return await this.authService.login(dto);
    }
    RefreshMemory(){
          try {
              localStorage.removeItem('userName');
              localStorage.removeItem('userId');
              localStorage.removeItem('profileName');
              localStorage.removeItem('authToken');
              localStorage.removeItem('roles');
              localStorage.removeItem('permissions');
              localStorage.clear();
              this.accessToken = null;
              this.refreshToken = null;    
          } catch (error) {
              console.log('refresh memory error:',error);
          }
    }
    async resetOnLogin(data:any){
          if(!data) return;
          const id = data?.result?.id;
          if(id){
              window.localStorage.setItem('userId',id );
          }
          const username = data?.result?.username;
          if(username){
              window.localStorage.setItem('userName', username);    
              // this.userStream.next(username);
              // this.logInStream.next(true);
          }
          const profileName = data?.result?.profileName;
          if(profileName){
              window.localStorage.setItem('profileName', profileName);
          }
          const idApp = data?.result?.idApp;
          if(idApp){
              window.localStorage.setItem('idApp', idApp);
          }
          const appLogo = data?.result?.appLogo;
          if(appLogo){
              window.localStorage.setItem('appLogo', appLogo);
          }
          const appName = data?.result?.appName;
          if(appName){
              window.localStorage.setItem('appName', appName);
          }
          const backColor = data?.result?.backColor;
          if(backColor){
              window.localStorage.setItem('backColor', backColor);
          }
          const foreColor = data?.result?.foreColor;
          if(foreColor){
              window.localStorage.setItem('foreColor', foreColor);
          }
          const accessToken = data?.result?.accessToken;
          if(accessToken){
              window.localStorage.setItem('accessToken', accessToken);
              this.accessToken= accessToken;
              this.refreshToken= data.result?.refreshToken;
          }
          const refreshToken = data?.result?.refreshToken;
          if(refreshToken){
              window.localStorage.setItem('refreshToken', refreshToken);
              this.refreshToken= data.result?.refreshToken;
          }
          const roles = data?.result?.roleNames;
          if(roles && roles.length>0){
            const hasSuperAdmin = roles.includes("Super Admin");
            if(hasSuperAdmin){
              window.localStorage.setItem('roles', "Super Admin");
              await this.setPermissions();
            }
            else{
              window.localStorage.setItem('roles', roles[0]);
              await this.setPermissions();
            }
              
              
          }
    }
    refreshTokens() {
          const apiUrl= `${environment.apiUrl}/auth`;
          const dto={
              id: this.getUserId(),
              refreshToken: this.getRefreshToken()
          }
          return this.http.post<TokensDto>(`${apiUrl}/refresh-token`, dto).pipe(
            tap((response) => {
              if (response && response.accessToken && response.refreshToken) {
                this.storeToken(response.accessToken, response.refreshToken);
                this.refreshTokenSubject.next(response.accessToken);
              } 
              // else {
              //   this.logout();
              // }
            }),
            finalize(() => (this.isRefreshing = false))
          );
    }
    async setPermissions(){
          try {
              const queryOptions : QueryRequestDto={};
              const roleName =window.localStorage.getItem('roles');
              queryOptions.filtersJson =`[{"field":"RoleName","operator":"eq","value":"${roleName}","combine":"and"}]`;      
              this.roleService.getAll(queryOptions).subscribe({
                  next: (res) => {
                      if (!res.success) {
                          return this.snackbarService.showMessage("error", res.message);
                      }
                      if (res.data?.result) {
                          const permissions = res.data?.result[0].permissionCodes;
                          window.localStorage.setItem('permissions', JSON.stringify(permissions));
                          this.permissionsStream.next(permissions as string[]);
                      }
                  },
                  error: (err) => {
                      this.snackbarService.showMessage("error", 'Unable to get permissions. Maybe connectivity issues.');
                  }
              });
          } catch (error) {
              this.snackbarService.showMessage('error',error as string);
          }
    }
    isAuthenticated(): boolean {
      const token = localStorage.getItem('accessToken');
      if (token) {
          return true;
      }
      return false;
    }
    private isTokenValid(token: string): boolean {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const expirationDate = new Date(payload.exp * 1000);
        return expirationDate > new Date(); // Check if token is expired
      } catch (error) {
        return false; // Invalid token format
      }
    }
    getAppLogo(): string | null {
      return `${environment.appImageUrl}`+ localStorage.getItem('appLogo');
    }
    logout() {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      this.userStream.next('');
    }
    storeToken(accessToken?: string, refreshToken?: string) {
      if(accessToken)
          localStorage.setItem('accessToken', accessToken);
      if(refreshToken)
      localStorage.setItem('refreshToken', refreshToken);
    }
    getUserId(): number | null {
      const userIdString = localStorage.getItem('userId');
      if (userIdString) {
        const userId = Number(userIdString);
        if (!isNaN(userId)) {
          return userId;
        }
      }
      return null; 
    }
    getUserName(): string | null {
      const userName = localStorage.getItem('userName');
      return userName; 
    }
    getAccessToken() {
      return localStorage.getItem('accessToken');
    }
    getRefreshToken() {
      return localStorage.getItem('refreshToken');
    }
    getRoleName(): string|null {
      return localStorage.getItem('roles');
    }
    getAppId(): number | null {
      const idApp = localStorage.getItem('idApp');
      return idApp !== null ? Number(idApp) : null;
    }
    getAppName(): string|null {
      return localStorage.getItem('appName');
    }
    getBackColor():string {
      return localStorage.getItem('backColor')|| 'blue';
    }
    getForeColor():string {
      return localStorage.getItem('foreColor')|| 'black';
    }
    setBackColor(backColor:string) {
      window.localStorage.setItem('backColor', backColor);
    }
    setForeColor(foreColor:string) {
      localStorage.setItem('foreColor', foreColor);
    }
    
  
}